import React from "react"
import styled from "styled-components"
import { Icon } from "@mostlycode/ui"
import Content from "../Content"
import Section from "../Section"
import Button from "../Button"
import { linkResolver } from "utils/linkResolver"
import { valuable } from "utils/worthy"

const StyledSection = styled(Section)`
  & + & {
    padding-top: 0;
  }
`

const StyledArticle = styled.article`
  padding-bottom: 4rem;
  h2 {
    text-transform: uppercase;

    + p {
      font-size: 1.8rem;
      line-height: 1.8;
    }
  }

  a {
    margin-top: 2rem;
  }
`

function ContentSimple({ link, display_text, rich_text, ...props }) {
  const html = (
    <StyledArticle>
      <Content content={rich_text} />
      {link && display_text && (
        <Button
          forwardedAs="a"
          icon="right"
          variant="secondary"
          size="sm"
          href={valuable(link) ? link.url || linkResolver(link._meta) : ""}
        >
          {display_text}
          <Icon icon="long-arrow-right" />
        </Button>
      )}
    </StyledArticle>
  )
  return <StyledSection align="center" prepend={html} />
}

export default ContentSimple
